@if (controller().totalItems() > 0) {
    @if (compact()) {
        <nav
            class="w-full min-w-0 overflow-hidden flex flex-col gap-1.5 border-t border-default-medium bg-neutral-primary-soft px-1.5 py-2"
            aria-label="Table pagination"
        >
            <div class="flex items-center justify-between gap-1 min-w-0 text-[11px] text-body">
                <span class="truncate min-w-0">
                    <span class="font-semibold text-heading">{{ controller().pageStart() }}</span>–<span class="font-semibold text-heading">{{ controller().pageEnd() }}</span>
                    of <span class="font-semibold text-heading">{{ controller().totalItems() }}</span>
                </span>
                <label class="flex items-center shrink-0">
                    <select
                        [value]="controller().pageSize()"
                        (change)="onPageSizeChange($event)"
                        aria-label="Rows per page"
                        class="max-w-14 py-0.5 pe-5 text-[11px] text-heading bg-neutral-secondary-medium border border-default-medium rounded-base focus:outline-none focus:ring-2 focus:ring-brand-medium focus:border-brand"
                    >
                        @for (size of controller().pageSizeOptions; track size) {
                            <option [value]="size" [selected]="size === controller().pageSize()">{{ size }}</option>
                        }
                    </select>
                </label>
            </div>

            <div class="flex items-center justify-center gap-1">
                <button
                    type="button"
                    (click)="controller().prev()"
                    [disabled]="controller().page() === 1"
                    aria-label="Previous page"
                    class="flex items-center justify-center h-8 w-8 leading-tight text-body bg-neutral-secondary-medium border border-default-medium rounded-base hover:bg-neutral-tertiary hover:text-heading disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
                >
                    <fa-icon [icon]="prevIcon"></fa-icon>
                </button>
                <span class="min-w-12 text-center text-[11px] font-medium text-heading tabular-nums">
                    {{ controller().page() }} / {{ controller().totalPages() }}
                </span>
                <button
                    type="button"
                    (click)="controller().next()"
                    [disabled]="controller().page() === controller().totalPages()"
                    aria-label="Next page"
                    class="flex items-center justify-center h-8 w-8 leading-tight text-body bg-neutral-secondary-medium border border-default-medium rounded-base hover:bg-neutral-tertiary hover:text-heading disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
                >
                    <fa-icon [icon]="nextIcon"></fa-icon>
                </button>
            </div>
        </nav>
    } @else {
        <nav
            class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-t border-default-medium bg-neutral-primary-soft px-4 py-3"
            aria-label="Table pagination"
        >
            <div class="flex flex-row flex-wrap items-center gap-3 text-xs text-body">
                <span>
                    Showing
                    <span class="font-semibold text-heading">{{ controller().pageStart() }}</span>–<span class="font-semibold text-heading">{{ controller().pageEnd() }}</span>
                    of <span class="font-semibold text-heading">{{ controller().totalItems() }}</span>
                </span>

                <label class="flex items-center gap-2">
                    <span class="hidden sm:inline">Rows:</span>
                    <select
                        [value]="controller().pageSize()"
                        (change)="onPageSizeChange($event)"
                        aria-label="Rows per page"
                        class="pe-6 py-1 text-xs text-heading bg-neutral-secondary-medium border border-default-medium rounded-base focus:outline-none focus:ring-2 focus:ring-brand-medium focus:border-brand"
                    >
                        @for (size of controller().pageSizeOptions; track size) {
                            <option [value]="size" [selected]="size === controller().pageSize()">{{ size }}</option>
                        }
                    </select>
                </label>
            </div>

            <ul class="inline-flex items-center -space-x-px text-sm self-end sm:self-auto">
                <li>
                    <button
                        type="button"
                        (click)="controller().prev()"
                        [disabled]="controller().page() === 1"
                        aria-label="Previous page"
                        class="flex items-center justify-center h-9 px-3 leading-tight text-body bg-neutral-secondary-medium border border-default-medium rounded-s-base hover:bg-neutral-tertiary hover:text-heading disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
                    >
                        <fa-icon [icon]="prevIcon"></fa-icon>
                    </button>
                </li>

                @for (pageNumber of controller().pageNumbers(); track pageNumber) {
                    <li>
                        <button
                            type="button"
                            (click)="controller().goToPage(pageNumber)"
                            [attr.aria-current]="pageNumber === controller().page() ? 'page' : null"
                            class="flex items-center justify-center h-9 px-3.5 leading-tight border border-default-medium cursor-pointer"
                            [class]="pageNumber === controller().page()
                                ? 'text-surface bg-primary border-primary font-semibold z-10'
                                : 'text-body bg-neutral-secondary-medium hover:bg-neutral-tertiary hover:text-heading'"
                        >
                            {{ pageNumber }}
                        </button>
                    </li>
                }

                <li>
                    <button
                        type="button"
                        (click)="controller().next()"
                        [disabled]="controller().page() === controller().totalPages()"
                        aria-label="Next page"
                        class="flex items-center justify-center h-9 px-3 leading-tight text-body bg-neutral-secondary-medium border border-default-medium rounded-e-base hover:bg-neutral-tertiary hover:text-heading disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
                    >
                        <fa-icon [icon]="nextIcon"></fa-icon>
                    </button>
                </li>
            </ul>
        </nav>
    }
}
